<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>图片流转配置管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="流转ID"
                        prop="id">
            <el-input placeholder="请输入图片流转配置ID"
                      v-model="search.id"></el-input>
          </el-form-item>
          <el-form-item label="流转名称"
                        prop="name">
            <el-input placeholder="请输入名称"
                      v-model="search.name"></el-input>
          </el-form-item>
          <el-form-item label="流转状态">
            <el-select
              class="width-max"
              clearable
              v-model="search.status"
              placeholder="请选择流转状态">
              <el-option
                v-for="(label, value) in status"
                :key="value"
                :label="label"
                :value="value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="批次ID"
                        prop="batch_id">
            <el-input placeholder="请输入批次ID"
                      v-model="search.batch_id"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="sj-icon-export"
                   @click="onExportPage()"></el-button>
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/img-flow-config/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="流转ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="name"
                         label="流转名称"
                         min-width="120">
          <template slot-scope="scope">

            <router-link :to="`/img-flow-config/detail/${scope.row.id}`">
              {{scope.row.name}}
            </router-link>
          </template>
        </el-table-column>
        <el-table-column prop="customer_id"
                         label="所属客户"
                         min-width="120">
          <template slot-scope="scope">
            {{scope.row.customer_name}}/{{scope.row.customer_id}}
          </template>
        </el-table-column>
        <el-table-column prop="project_id"
                         label="所属项目"
                         min-width="120">
          <template slot-scope="scope">
            {{scope.row.project_name}}/{{scope.row.project_id}}
          </template>
        </el-table-column>
        <el-table-column prop="batch_id"
                         label="所属批次"
                         min-width="120">
          <template slot-scope="scope">
            {{scope.row.batch_name}}/{{scope.row.batch_id}}
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         min-width="180"></el-table-column>
        <el-table-column label="状态"
                         min-width="80">
          <template slot-scope="scope">
            {{status[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         min-width="120">
          <template slot-scope="scope">
            <button-gutter>
              <router-link :to="{path: '/img-flow-order/table', query: {flow_id: scope.row.id}}">
                <el-button size="mini">工单列表
                </el-button>
              </router-link>
              <router-link :to="`/img-flow-config/update/${scope.row.id}`">
                <el-button size="mini">编辑
                </el-button>
              </router-link>
              <el-button type="primary"
                         size="mini"
                         @click="onCopy(scope.row, scope.$index)">复制
              </el-button>
              <el-button
                :disabled="scope.row.status === 0"
                type="warning"
                size="mini"
                @click="onReset(scope.row, scope.$index)">重置
              </el-button>

              <el-button v-if="scope.row.status === 0"
                         type="success"
                         size="mini"
                         @click="onOpen(scope.row, scope.$index)">开启
              </el-button>
              <el-button v-if="scope.row.status === 1"
                         type="danger"
                         size="mini"
                         @click="onClose(scope.row, scope.$index)">关闭
              </el-button>
            </button-gutter>
            <!--<el-button type="danger"-->
            <!--size="mini"-->
            <!--@click="onDelete(scope.$index, table)">删除-->
            <!--</el-button>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../img-flow-config.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        name: null,
        status: null,
        batch_id: null,
      },
      status: {
        0: '已关闭',
        1: '已开启',
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getImgFlowConfigTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {})
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    // onDelete (index, rows) {
    //   this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
    //     request.common('deleteImgFlowConfigData', {id: rows[index].id}).then(() => {
    //       this.$message.success('删除成功')
    //       rows.splice(index, 1)
    //     })
    //   }).catch(() => {
    //     this.$message.info('已取消删除')
    //   })
    // },
    onCopy (row, index) {
      this.$confirm('此操作将复制该行数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('copyImgFlowConfig', {id: row.id}).then(({data}) => {
          this.$message.success('复制成功')
          this.table.unshift(filter.copyJson({...row, id: data.id}))
        })
      }).catch(() => {
        this.$message.info('已取消复制')
      })
    },
    onOpen (row, index) {
      this.$confirm('此操作将开启流转, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('openImgFlowConfig', {id: row.id}).then(() => {
          this.$message.success('流转开启成功')
          row.status = 1
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    onClose (row, index) {
      this.$confirm('此操作将关闭流转, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('closeImgFlowConfig', {id: row.id}).then(() => {
          this.$message.success('流转关闭成功')
          row.status = 0
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    onReset (row, index) {
      this.$confirm('此操作将重置流转, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('resetImgFlowConfig', {id: row.id}).then(() => {
          this.$message.success('流转重置成功')
        })
      }).catch(() => {
        this.$message.info('已取消重置')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/img-flow-config/pages/ImgFlowConfigTable.vue